module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainLayout"
  }, [_c('section', {
    staticClass: "listLayout"
  }, _vm._l((_vm.firebaseByVotes), function(video) {
    return _c('div', {
      key: video.id,
      staticClass: "videoElement"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "votes-cont"
    }, [_c('div', {
      staticClass: "votes-label"
    }, [_vm._v("Voti")]), _vm._v(" "), _c('div', {
      staticClass: "votes-counter"
    }, [_vm._v(_vm._s(video.votes))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('videoplayer', {
      attrs: {
        "videoID": video.videoID,
        "elID": video.id,
        "previewType": "image",
        "vote": false
      }
    })], 1)])
  }), 0), _vm._v(" "), _vm._l((_vm.firebaseByVotes), function(video) {
    return _c('prefetch-img-thumb', {
      key: video.id,
      attrs: {
        "videoID": video.videoID
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a93e4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listLayout.vue
// module id = 239
// module chunks = 1